<div class="bg-white rounded-lg shadow-sm p-4 hover:bg-gray-50 transition-colors flex items-center">
  <app-avatar [src]="user().avatarThumbnailUrl" [name]="user().displayName" [seed]="user().id" />

  <!-- Name with platform + status dot + role, phone below -->
  <div class="flex-1 ml-4">
    <div class="flex items-center justify-between">
      <div class="flex items-center gap-3">
        <div class="flex items-center gap-2">
          <div class="font-medium text-gray-900">
            {{ user().displayName }}
          </div>
          @if (user().operatingSystem === 'Android') {
            <img src="/android.svg" alt="Android" title="Android" class="w-4 h-4 opacity-70" />
          } @else {
            <img src="/apple.svg" alt="iOS" title="iOS" class="w-4 h-4 opacity-70" />
          }
          <!-- Status dot -->
          @if (user().isActive !== false) {
            <div class="w-2 h-2 bg-green-500 rounded-full"></div>
          } @else {
            <div class="w-2 h-2 bg-red-500 rounded-full"></div>
          }
        </div>
        <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
          {{ user().role }}
        </span>
      </div>
      <div class="ml-4 text-sm text-gray-500">
        {{ user().email }}
      </div>
    </div>

    <div class="text-sm text-gray-500 mt-1">
      {{ user().phoneNumber }}
    </div>
  </div>

  <!-- Details button -->
  <div class="flex justify-end ml-4">
    <button
      class="px-4 py-2 bg-button-primary text-white rounded-full text-sm hover:bg-button-primary-hover disabled:opacity-50 disabled:cursor-not-allowed shadow"
      (click)="navigateToDetails()"
    >
      Details
    </button>
  </div>
</div>
